module.exports = __webpack_public_path__ + "media/wyposazenie/skrzynia-biegow@3x-5e1c1d58.svg";